import dayjs from 'dayjs';
import { migrateExpenseClaimLines, setExpenseCompanyNamesSnapshot } from '../components/ApprovalCenter/ExpenseClaimForm';
import { resolveExpensePayeeRefFromFormData } from './expenseClaimSubject';
import { isLoanDocType, PREPAYMENT_DOC_TYPE } from './prepaymentDocTypeLabels';

export function prefillExpenseClaimForm(form, formData = {}) {
  const fd = formData || {};
  const defaultBudgetOrg = fd.budget_org_code || fd.applicant_dept_code;
  setExpenseCompanyNamesSnapshot(
    fd.expense_company_name
      ? [fd.expense_company_name]
      : (Array.isArray(fd.expense_company_names) ? fd.expense_company_names : undefined)
  );
  form.setFieldsValue({
    expense_company_id: fd.expense_company_id,
    applicant_dept_code: fd.applicant_dept_code,
    category_id: fd.category_id,
    reason: fd.reason,
    payee_type: fd.payee_type || 'employee',
    payee_ref: resolveExpensePayeeRefFromFormData(fd),
    payee_name: fd.payee_name,
    bank_name: fd.bank_name,
    bank_branch_name: fd.bank_branch_name,
    bank_account_no: fd.bank_account_no,
    id_card_no: fd.payee_id_card_no,
    tax_no: fd.payee_tax_no,
    payment_date: fd.payment_date ? dayjs(fd.payment_date) : null,
    expense_occurrence_month: fd.expense_occurrence_month
      ? dayjs(`${String(fd.expense_occurrence_month).slice(0, 7)}-01`)
      : (fd.expense_occurrence_date ? dayjs(fd.expense_occurrence_date) : dayjs()),
    lines: fd.lines?.length
      ? migrateExpenseClaimLines(fd, defaultBudgetOrg)
      : undefined,
    urgency: fd.urgency || 'normal',
    other_attachments: fd.other_attachments || [],
    remark: fd.remark || ''
  });
}

export function prefillPrepaymentForm(form, formData = {}) {
  const fd = formData || {};
  const payee = fd.payee_snapshot || {};
  const defaultBudgetOrg = fd.budget_org_code || fd.applicant_dept_code;
  const isLoan = isLoanDocType(fd.doc_type);
  const payeeType = fd.payee_type || payee.payee_type || (isLoan ? 'employee' : 'external_person');
  form.setFieldsValue({
    doc_type: fd.doc_type || PREPAYMENT_DOC_TYPE,
    expense_company_id: fd.expense_company_id,
    applicant_dept_code: fd.applicant_dept_code,
    category_id: fd.category_id,
    reason: fd.reason,
    urgency: fd.urgency || 'normal',
    expected_invoice_date: fd.expected_invoice_date ? dayjs(fd.expected_invoice_date) : undefined,
    payee_type: payeeType,
    payee_ref: payeeType === 'employee'
      ? (fd.employee_no || payee.employee_no || undefined)
      : (fd.payee_id || payee.payee_id || undefined),
    payee_name: fd.payee_name || payee.name,
    bank_name: fd.bank_name || payee.bank_name,
    bank_branch_name: fd.bank_branch_name || payee.bank_branch_name,
    bank_account_no: fd.bank_account_no || payee.bank_account_no,
    id_card_no: fd.payee_id_card_no || payee.id_card_no,
    tax_no: fd.payee_tax_no || payee.tax_no,
    expense_occurrence_month: fd.expense_occurrence_month
      ? dayjs(`${String(fd.expense_occurrence_month).slice(0, 7)}-01`)
      : (fd.expense_occurrence_date ? dayjs(fd.expense_occurrence_date) : dayjs()),
    lines: fd.lines?.length
      ? fd.lines.map((line) => ({
        expense_detail: line.expense_detail,
        budget_org_code: line.budget_org_code || defaultBudgetOrg,
        budget_splits: line.budget_splits,
        subitem_id: line.subitem_id,
        prepay_amount: line.prepay_amount
      }))
      : [{ expense_detail: '', budget_org_code: defaultBudgetOrg, prepay_amount: undefined }],
    other_attachments: fd.other_attachments || [],
    no_invoice_commitment_files: fd.no_invoice_commitment_files || [],
    remark: fd.remark || ''
  });
}
